// extracted by mini-css-extract-plugin
export var actionText = "_q9-4";
export var container = "_q9-0";
export var leftSection = "_q9-1";
export var rightSection = "_q9-2";
export var settingsButton = "_q9-6";
export var settingsIcon = "_q9-7";
export var shortcut = "_q9-5";
export var shortcutGroup = "_q9-3";